import { Field } from 'react-final-form';
import { required } from '../../../helpers';
import FormError from '../../Common/FormError';
import LocationWithAddress from '../../Common/LocationWithAddress';

const EquityLoanForm = () => {
  return (
    <>
      <div className='mb-5 col-lg-12'>
        <label className='form-label mb-3'>Project Name</label>
        <Field name='project_name' type='text' validate={(v) => required(v, 'Project name')}>
          {({ input, meta }) => (
            <>
              <div className='mb-3'>
                <input type='text' {...input} className='form-control form-control-lg form-control-solid' />
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>

      <div className='row'>
        <div className='mb-5 col-lg-6'>
          <label className='form-label mb-3'>Loan Amount</label>
          <Field name='loan_amount' type='number' validate={(v) => required(v, 'Loan amount')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <input type='number' {...input} className='form-control form-control-lg form-control-solid' />
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>

        <div className='mb-5 col-lg-6'>
          <label className='form-label mb-3'>Loan Tenure</label>
          <Field name='loan_tenure' type='number' validate={(v) => required(v, 'Loan tenure')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <input type='number' {...input} className='form-control form-control-lg form-control-solid' />
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>
      </div>

      <LocationWithAddress label='Property Address' addressFormName='property_address' cityFormName='property_city' stateFormName='property_state' countryFormName='property_country' />

      <div className='row mt-5'>
        <div className='mb-5 col-lg-6'>
          <label className='form-label mb-3'>Estimated Property Value</label>
          <Field name='property_value' type='number' validate={(v) => required(v, 'Loan amount')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <input type='number' {...input} className='form-control form-control-lg form-control-solid' />
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>

        <div className='mb-5 col-lg-6'>
          <label className='form-label'>How was the value determined</label>
          <Field name='valued_method' type='text' validate={(v) => required(v, 'Method of evaluation')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <input type='text' {...input} className='form-control form-control-lg form-control-solid' />
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>
      </div>
    </>
  );
};

export default EquityLoanForm;
